
import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Play, StopCircle, Pause, RotateCcw, AlertCircle } from 'lucide-react';
import { useFasting } from '@/contexts/FastingContext';
import { useToast } from '@/hooks/use-toast';
import { hasCookieConsent } from '@/utils/cookies';

export const TimerControls: React.FC = () => {
  const { isActive, isPaused, startFast, stopFast, pauseFast, resumeFast, timeElapsed } = useFasting();
  const [initialized, setInitialized] = useState(false);
  const { toast } = useToast();
  const cookiesEnabled = hasCookieConsent();

  // Log component state for debugging
  useEffect(() => {
    console.log(`[TimerControls] Rendered - isActive: ${isActive}, isPaused: ${isPaused}, timeElapsed: ${timeElapsed}`);
    setInitialized(true);
  }, [isActive, isPaused, timeElapsed]);

  // Warn about cookies when user tries to start without cookie consent
  const handleStartFast = () => {
    startFast();
    
    if (!cookiesEnabled) {
      toast({
        title: "Cookie permission needed",
        description: "Enable cookies to save your fasting progress between browser sessions.",
        variant: "default",
      });
    }
  };

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex space-x-3">
        {!isActive ? (
          <Button onClick={handleStartFast} size="lg" className="rounded-full px-8 bg-fasttrack-blue hover:bg-fasttrack-blue/90">
            <Play className="mr-2" size={20} /> Start
          </Button>
        ) : isPaused ? (
          <>
            <Button onClick={resumeFast} size="lg" className="rounded-full px-8 bg-fasttrack-blue hover:bg-fasttrack-blue/90">
              <Play className="mr-2" size={20} /> Resume
            </Button>
            <Button onClick={stopFast} size="lg" variant="destructive" className="rounded-full px-8">
              <StopCircle className="mr-2" size={20} /> Stop
            </Button>
          </>
        ) : (
          <>
            <Button onClick={pauseFast} size="lg" variant="outline" className="rounded-full px-8 border-fasttrack-blue text-fasttrack-blue hover:bg-fasttrack-blue/10">
              <Pause className="mr-2" size={20} /> Pause
            </Button>
            <Button onClick={stopFast} size="lg" variant="destructive" className="rounded-full px-8">
              <StopCircle className="mr-2" size={20} /> Stop
            </Button>
          </>
        )}
      </div>
      
      {!cookiesEnabled && (
        <div className="text-center text-amber-600 text-xs flex items-center justify-center">
          <AlertCircle className="h-3 w-3 mr-1" />
          <span>Cookie permission needed to save progress</span>
        </div>
      )}
    </div>
  );
};
